var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _vm._l(_vm.config.section, function(item_value, item) {
        return [
          (item == "search-bar") & item_value ? _vm._t("search-bar") : _vm._e(),
          _vm._v(" "),
          (item == "home-sell-estate") & item_value
            ? _vm._t("home-sell-estate")
            : _vm._e(),
          _vm._v(" "),
          (item == "advertising") & item_value
            ? _vm._t("advertising")
            : _vm._e(),
          _vm._v(" "),
          (item == "recent-estates") &
          item_value &
          (_vm.$root.hasMarketingCookies ||
            (_vm.config_cookies && !_vm.config_cookies.cookies))
            ? _c(
                "section",
                [
                  _c("recent-estates", {
                    attrs: {
                      sector: _vm.sector == "can" ? "construction" : "estate",
                      title: _vm.trans("titles.recent_estates")
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (item == "opt-out") & item_value ? _vm._t("opt-out") : _vm._e(),
          _vm._v(" "),
          (item == "home-services") & item_value
            ? _c(
                "section",
                { staticClass: "home-services" },
                [
                  _c("home-services", {
                    attrs: { config: _vm.config.services }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (item == "magazine") & item_value ? _vm._t("magazine") : _vm._e(),
          _vm._v(" "),
          (item == "home-news") & item_value
            ? _c("section", { staticClass: "home-news" }, [
                _c(
                  "div",
                  { staticClass: "container" },
                  [_c("home-news", { attrs: { config: _vm.config.news } })],
                  1
                )
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }